/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ToolVariationGroup,
  ToolVariationGroup$inboundSchema,
} from "./toolvariationgroup.js";

export type ListToolVariationGroupsResult = {
  groups: Array<ToolVariationGroup>;
};

/** @internal */
export const ListToolVariationGroupsResult$inboundSchema: z.ZodMiniType<
  ListToolVariationGroupsResult,
  unknown
> = z.object({
  groups: z.array(ToolVariationGroup$inboundSchema),
});

export function listToolVariationGroupsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListToolVariationGroupsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListToolVariationGroupsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListToolVariationGroupsResult' from JSON`,
  );
}
